import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type {
  PaywallCheckoutPreview,
  PaywallPrice,
  PaywallPriceScenario,
} from "@circle-react/types";
import { BadgeV2 } from "@circle-react-shared/uikit/BadgeV2";

interface StatusBadgeProperty {
  className: string;
  labelClassName: string;
  labelLocale: string;
}

interface PriceBadgeProps {
  preview?: PaywallCheckoutPreview;
  price?: PaywallPrice;
  properties: Record<PaywallPriceScenario, StatusBadgeProperty | null>;
}

export const PriceBadge = ({ price, preview, properties }: PriceBadgeProps) => {
  if (!price && !preview) {
    return null;
  }

  const index = price?.scenario || preview?.preview_scenario || "value";
  const property = properties[index];

  if (property) {
    return (
      <BadgeV2
        label={t([property.labelLocale], { count: price?.trial_days })}
        className={classNames("rounded-md border-0", property.className)}
        labelClassName={property.labelClassName}
        textSizeClassName="text-xs"
      />
    );
  }

  return null;
};
